module.exports = __webpack_public_path__ + "static/smiling-guy-97144e9522d646264e10601e042586ad.png";